// extracted by mini-css-extract-plugin
module.exports = {"className":"bn-BD_className__PFd3S"};